import { render, staticRenderFns } from "./onlyInChrome.vue?vue&type=template&id=f9f851d6&"
import script from "./onlyInChrome.vue?vue&type=script&lang=js&"
export * from "./onlyInChrome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports